export const getDescription = (title: string) => {
  const item = GroupToolTip.find(group => group.group === title);
  if (item) {
    return item.description;
  }
  return '';
};

export const GroupToolTip = [
  {
    group: 'Company Facilities',
    description: 'Emissions resulting from the operation of buildings and facilities owned or controlled by the reporting company, including office spaces, manufacturing plants, warehouses, and other physical locations used for business activities.'
  },
  {
    group: 'Company Vehicles',
    description: 'Emissions from the operation of vehicles owned or controlled by the reporting company, including cars, trucks, vans, and any other vehicles used for transportation of goods or personnel as part of business operations.'
  },
  {
    group: 'Purchased Energy',
    description: 'Emissions associated with the production of energy (such as electricity, heating, and cooling) purchased by the reporting company from external suppliers, including the upstream activities of extracting, producing, and distributing the energy.'
  },
  {
    group: 'Purchased Goods and Services',
    description: 'Extraction, production, and transportation of goods and services purchased or acquired by the reporting company, not otherwise included in Capital Goods, Fuel and Energy Scope 3, Upstream Transportation and Distribution, Waste Generated in Operations, Buisness Travel, Employee Commuting and Upstream Leased Assets.'
  },
  {
    group: 'Capital Goods',
    description: 'Extraction, production, and transportation of capital goods purchased or acquired by the reporting company.'
  },
  {
    group: 'Fuel and Energy Related Activities',
    description: `Extraction, production, and transportation of fuels and energy purchased or acquired by the reporting company, not already accounted for in Scope 1 or Scope 2, including:

a) Upstream emissions of purchased fuels (extraction, production, and transportation of fuels consumed by the reporting company).

b) Upstream emissions of purchased electricity(extraction, production, and transportation of fuels consumed in the generation of electricity, steam, heating, and cooling consumed by the reporting company.

c) Transmission and distribution (T&D) losses(generation of electricity, steam, heating and cooling that is consumed (i.e., lost) in a T&D system) - reported by the end user.

d) Generation of purchased electricity that is sold to end users (generation of electricity, steam, heating, and cooling that is purchased by the reporting company and sold to end users) - reported by utility company or energy retailer only.`
  },
  {
    group: 'Upstream Transportation and Distribution',
    description: `Transportation and distribution of products purchased by the reporting company between a company’s tier 1 suppliers and its own operations (in vehicles and facilities not owned or controlled by the reporting company.
    
Transportation and distribution services purchased by the reporting company, including inbound logistics, outbound logistics (e.g., of sold products), and transportation and distribution between a company’s own facilities (in vehicles and facilities not owned or controlled by the reporting company).`
  },
  {
    group: 'Waste Generated in Operations',
    description: 'Disposal and treatment of waste generated in the reporting company’s operations (in facilities not owned or controlled by the reporting company).'
  },
  {
    group: 'Business Travel',
    description: 'Transportation of employees for business related activities (in vehicles not owned or operated by the reporting company).'
  },
  {
    group: 'Employee Commuting',
    description: 'Transportation of employees between their homes and their worksites (in vehicles not owned or operated by the reporting company).'
  },
  {
    group: 'Upstream Leased Assets',
    description: 'Operation of assets leased by the reporting company (lessee) not included in Scope 1 and Scope 2 - reported by lessee.'
  },
  {
    group: 'Downstream Transportation and Distribution',
    description: 'Transportation and distribution of products sold by the reporting company between the reporting company’s operations and the end consumer (if not paid for by the reporting company), including retail and storage (in vehicles and facilities not owned or controlled by the reporting company).'
  },
  {
    group: 'Processing of Sold Products',
    description: 'Processing of intermediate products sold by downstream companies (e.g., manufacturers).'
  },
  {
    group: 'Use of Sold Products',
    description: 'End use of goods and services sold by the reporting company.'
  },
  {
    group: 'End of Life Treatment of Sold Products',
    description: 'Waste disposal and treatment of products sold by the reporting company at the end of their life.'
  },
  {
    group: 'Downstream Leased Assets',
    description: 'Operation of assets owned by the reporting company (lessor) and leased to other entities, not included in Scope 1 and Scope 2 - reported by lessor.'
  },
  {
    group: 'Franchises',
    description: 'Operation of franchises, not included in Scope 1 and Scope 2 - reported by franchisor.'
  },
  {
    group: 'Investments',
    description: 'Operation of investments (including equity and debt investments and project finance), not included in Scope 1 or Scope 2.'
  },

]